import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useContent } from "./ContentContext";
import { useTx, txtStyle } from "./siteText";
import { getTodayStatus } from "./hoursStatus";

export const OpenBanner = () => {
  const { settings } = useContent();
  const tx = useTx();
  const [status, setStatus] = useState(() => getTodayStatus(settings.hours));

  useEffect(() => {
    setStatus(getTodayStatus(settings.hours));
    const id = setInterval(() => setStatus(getTodayStatus(settings.hours)), 60000);
    return () => clearInterval(id);
  }, [settings.hours]);

  const open = status.isOpen;
  const dot = open ? "#5B8A5B" : "#C8322B";

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.3 }}
      className="inline-flex items-center gap-2.5 rounded-full bg-white border border-cantina-line pl-3 pr-4 py-1.5 shadow-sm"
      data-testid="open-banner"
    >
      <span className="relative flex h-2.5 w-2.5">
        {open && <span className="absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping" style={{ backgroundColor: dot }} />}
        <span className="relative inline-flex rounded-full h-2.5 w-2.5" style={{ backgroundColor: dot }} />
      </span>
      <span className="font-sans text-cantina-ink" style={txtStyle(tx(open ? "banner.open" : "banner.closed"))} data-testid="open-banner-status">
        {open ? tx("banner.open").text : tx("banner.closed").text}
      </span>
      {status.todayTime && (
        <>
          <span className="w-px h-3.5 bg-cantina-line" />
          <span className="font-sans text-xs text-cantina-ink/60">
            {status.todayLabel}: {status.todayTime}
          </span>
        </>
      )}
    </motion.div>
  );
};
